import { cardRepository } from '@webapp/modules/spending-cards/data-access/repositories/CardRepository'
import { ActivatePhysicalCardUseCase } from './ActivatePhysicalCardUseCase'

export const activatePhysicalCardUseCase = new ActivatePhysicalCardUseCase({
  cardRepository,
}).execute
